<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="75%" @open="addOpen" :close-on-click-modal="false">
    <el-card>
      <el-table :data="list" stripe border :cell-style="{ textAlign: 'center' }">
        <el-table-column prop="id" label="ID" align="center" width="70px"></el-table-column>
        <el-table-column prop="sub_mail" label="收件人" align="center"></el-table-column>
        <el-table-column prop="mg_domain" label="发送域名" align="center"></el-table-column>
        <el-table-column label="发送状态" align="center">
          <template slot-scope="scope">
            {{scope.row.status | getStatusTitle(sendStatusList)}}
          </template>
        </el-table-column>
        <el-table-column label="是否已读" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.is_read === 1">已读</span>
            <span v-else>未读</span>
          </template>
        </el-table-column>
        <el-table-column label="发送时间" align="center">
          <template slot-scope="scope">
            {{scope.row.create_time | dateTimeFormat}}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="param.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="param.count"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>
  </el-dialog>
</template>

<script>
export default {
  name: 'ghost_send_log',
  props: [
    'visible', 'id'
  ],
  data () {
    return {
      title: '',
      list: [],
      total: 0,
      pageTotal: 1,
      param: {
        gh_post_id: '',
        page: 1,
        count: 10
      },
      sendStatusList: [
        { id: 20, title: '成功' },
        { id: 40, title: '失败' }
      ]
    }
  },
  filters: {
    getStatusTitle (id, statusList) {
      for (var i = 0; i < statusList.length; i++) {
        if (statusList[i].id === id) {
          return statusList[i].title
        }
      }
      return ''
    }
  },
  methods: {
    closeDialog () {
      this.param = {
        gh_post_id: '',
        page: 1,
        count: 10
      }
      this.$emit('closeLogDialog')
    },
    addOpen () {
      this.param.gh_post_id = this.id
      this.getList()
    },
    async getList () {
      const res = await this.$http.get('/admin/gh_sub_log/list', this.param)
      if (res.code === 0) {
        this.list = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getList()
    }
  }
}
</script>

<style>
</style>
